import ContactUsContextProvider from "../../../context/contactus/provider";
import PageDetails from "../../general/details";
import {useTranslation} from "react-i18next";
import { useParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import ContactUsContext from "../../../context/contactus/context";
import AppContext from "../../../context/app/context";
import Spin from "../../general/antd/spin";
import Descriptions from "../../general/antd/descriptions";
import {Descriptions as AntdDescriptions} from "antd";
import Tag from "../../general/antd/tag";
import { getContactUsStatus, getContactUsStatusColors } from "../../../models/contactus/enum";


interface Props {
}

const ContactUsDetails: React.FC<Props> = () => {
    const {t} = useTranslation();
    const {id} = useParams();
    const { details, actions, loading } = useContext(ContactUsContext);
    const {direction} = useContext(AppContext);

    useEffect(() => {
        const getDetails = async () => {
            id && (await actions.getDetails(Number(id)));
        };
        getDetails();
    }, [direction]);

    return (
        <PageDetails
            title={t("details")}
            subtitle={t("contactus_manager")}
        >
            {loading.includes("details") ? (
                <Spin/>
            ) : (
                <Descriptions size="small" column={1} bordered>
                    <AntdDescriptions.Item label={t("id")}>
                        {details?.id}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("name")}>
                        {details?.name ?? "-"}
                    </AntdDescriptions.Item>
                    <AntdDescriptions.Item label={t("contact_way")}>
                        {details?.contact_way ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("message")}>
                        {details?.message ?? "-"}
                    </AntdDescriptions.Item>
                        <AntdDescriptions.Item label={t("status")}>
                            {<Tag color={getContactUsStatusColors(Number(details?.status))} title={getContactUsStatus(Number(details?.status))}/>}
                    </AntdDescriptions.Item>
                   
                </Descriptions>
            )}
        </PageDetails>
    )
}

const ContactUsDetailsPage = () => {
    return (
        <ContactUsContextProvider>
            <ContactUsDetails/>
        </ContactUsContextProvider>
    );
};
export default ContactUsDetailsPage;